<template>
  <el-drawer :wrapperClosable="false" :visible.sync="dialogVisble" size="50%" :show-close="false" destroy-on-close>
    <template #title>
      <div style="height: 50px">
        <div class="staff_head">
          <div class="staff_l">
            <img src="@/assets/structure/close.png" class="staff_close" @click="handleClose" />
            <div>访客审核</div>
          </div>
          <div style="text-align: right;">
            <el-button  @click="handleClose">取消</el-button>
          </div>
        </div>
      </div>
    </template>
    <div style="padding:0 20px;">
      <el-form :model="form" :rules="rules" label-position="top">
        <el-card header="访客信息" class="visitor-type-card">
          <template #header>
            <div style="display: flex;align-items: center;">
              <svg t="1772008988621" class="icon" viewBox="0 0 1099 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="10423" width="14" height="14"><path d="M877.99188969 683.21401719a204.25531875 204.25531875 0 0 0 82.90362937-164.60575688 199.02878625 199.02878625 0 1 0-397.69712062-16.82102625v16.82102625a204.85606969 204.85606969 0 0 0 83.50438031 164.60575688 334.01752219 334.01752219 0 0 0-180.22528219 275.14393031c0 18.62327906 9.612015 33.6420525 27.63454313 33.6420525h540.67584562c18.02252813 0 27.63454312-15.01877344 27.63454313-33.6420525a336.42052594 336.42052594 0 0 0-180.22528219-275.14393031z" p-id="10424" fill="#1296db"></path><path d="M554.18713437 665.79224A281.75219062 281.75219062 0 0 1 494.71279063 452.52565719a269.73717188 269.73717188 0 0 1 103.92991312-174.81852282 270.93867375 270.93867375 0 0 1 245.70713344-32.44055156 186.83354156 186.83354156 0 0 1 82.90362937 60.07509469 33.04130156 33.04130156 0 0 0 33.04130156-33.04130156V212.22528125a173.61702094 173.61702094 0 0 0-165.80725875-180.22528125H197.9418275A173.61702094 173.61702094 0 0 0 32.13456781 212.22528125v586.33291687a173.61702094 173.61702094 0 0 0 165.80725969 180.22528125H332.5100375a29.43679594 29.43679594 0 0 0 33.04130156-25.83229031v-3.60450562a201.852315 201.852315 0 0 1 18.02252813-76.29536907A471.58948688 471.58948688 0 0 1 452.660225 758.90863625a456.57071344 456.57071344 0 0 1 101.52690938-93.11639625zM264.62518156 176.78097594h240.300375a24.0300375 24.0300375 0 0 1 22.82853563 21.02628281 26.43304125 26.43304125 0 0 1-21.02628281 30.63829781h-240.300375a24.0300375 24.0300375 0 0 1-25.83229032-20.42553187v-3.60450563a24.63078844 24.63078844 0 0 1 22.82853563-25.83229031z m-91.3141425-6.00750938a32.44055063 32.44055063 0 0 1 28.836045 48.66082594 33.04130156 33.04130156 0 0 1-28.836045 16.22027531 32.44055063 32.44055063 0 0 1 0-64.88110125z m189.23654532 472.19023781H163.69902406a30.21777188 30.21777188 0 0 1-6.60826031-60.07509375 12.01501875 12.01501875 0 0 1 6.60826031 0H362.54758438a30.21777188 30.21777188 0 0 1 6.60826031 60.07509375z m66.68335406-164.00500593H163.69902406c-18.62327906 0-33.6420525-9.612015-32.44055062-28.836045a29.43679594 29.43679594 0 0 1 29.43679593-29.43679594h268.53566907a29.43679594 29.43679594 0 0 1 32.44055062 26.43304125V452.52565719a29.43679594 29.43679594 0 0 1-28.836045 29.43679594z" p-id="10425" fill="#1296db"></path></svg>
              <span style="margin-left: 6px;">访客信息</span>
            </div>
          </template>
          <el-row :gutter="20">
            <el-col :span="8">
              <el-form-item label="访客姓名" prop="visitor">
                <div style="display: flex;justify-content: start;align-items: center">
                  <el-image v-if="form.photoBase64"
                            style="width: 26px; height: 26px;border-radius: 50%;margin-right: 5px;"
                            :src="'data:image/jpeg;base64,'+form.photoBase64"
                            :preview-src-list="['data:image/jpeg;base64,'+form.photoBase64]">
                  </el-image>
                  <div v-else style="display: flex;justify-content: center;align-items: center; width: 26px;height: 26px;border-radius: 50%;margin-right: 5px;background: #b1b0b0;">
                    <i class="el-icon-user" style="font-size: 18px;color: #fff;"></i>
                  </div>
                  <div>{{form.visitor}}</div>
                </div>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="访客手机号" prop="phoneNum">
                {{ form.phoneNum || '-' }}
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="访客性别" prop="sex">
                {{ form.sex || '-' }}
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="访客身份证号" prop="idno">
                {{ form.idno || '-' }}
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="随行人数" prop="personCnt">
                {{ form.personCnt || '-' }}
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="车牌号" prop="plateNum">
                {{ form.plateNum || '-' }}
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="访客工作单位" prop="visitorCompanyName">
                {{ form.visitorCompanyName || '-' }}
              </el-form-item>
            </el-col>
            <el-col :span="24" v-if="form.shareLink">
              <div class="vistor-box-link">
                <div class="link-text">
                  <span class="link-text-title">
                    访客链接：
                    <span class="copy_content">{{ form.shareLink }}</span>
                  </span>
                  <span class="link-text-tip">您可以将该链接发给访客，用来完善信息或查看通行码</span>
                </div>
                <div class="link-btns">
                  <el-button type="success" plain size="small" @click="sendSms()" :loading="smsLoading">重发短信</el-button>
                  <el-button type="primary" class="copy" size="small" @click="copyLink(form.shareLink)">复制链接</el-button>
                </div>
              </div>
            </el-col>
          </el-row>
        </el-card>
        <el-card header="到访信息" class="visitor-type-card" style="margin-top: 20px">
          <template #header>
            <div style="display: flex;align-items: center;">
              <svg t="1772009168953" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="13332" width="12" height="12"><path d="M932.48 256V75.84A74.56 74.56 0 0 0 857.92 0H124.48a74.56 74.56 0 0 0-74.56 75.84v864a74.56 74.56 0 0 0 74.56 74.56h733.44a74.56 74.56 0 0 0 74.56-74.56v-608H50.24V256zM518.4 87.04a62.08 62.08 0 1 1-62.08 62.08 62.08 62.08 0 0 1 62.08-62.08z m-160 0a62.08 62.08 0 1 1-63.04 62.08 62.08 62.08 0 0 1 62.08-62.08z m-160 0a62.08 62.08 0 1 1-64 62.08 62.08 62.08 0 0 1 62.08-62.08zM563.2 595.2a24.96 24.96 0 0 1 34.24-8.64l225.92 134.08a24.96 24.96 0 0 1 10.88 13.44 24.64 24.64 0 0 1-15.36 32l-80 27.84 64 112.96a24.96 24.96 0 0 1-9.28 33.92l-27.52 16a24.32 24.32 0 0 1-33.92-9.28l-64-112.96-64 55.68a26.88 26.88 0 0 1-16 6.08 24.96 24.96 0 0 1-25.28-24.96l-3.2-263.36a25.92 25.92 0 0 1 3.52-12.8z" fill="#1296db" p-id="13333"></path></svg>
              <span style="margin-left: 6px;">到访信息</span>
            </div>
          </template>
          <el-row :gutter="20">
            <el-col :span="8">
              <el-form-item label="被访人" prop="user">
                {{ form?.user?.name || '-' }}
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="被访人手机号" prop="user">
                {{ form?.user?.phone || '-' }}
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="访客类型" prop="user">
                {{ form?.visitorType?.name || '-' }}
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="预计访问时间" prop="visitDate">
                {{ form.visitDate || '-' }}
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="预计离访时间" prop="visitEndDate">
                {{ form.visitEndDate || '-' }}
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="备注" prop="remark">
                {{ form.remark || '-' }}
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="访问事由" prop="reason">
                {{ form.reason || '-' }}
              </el-form-item>
            </el-col>
            <el-col :span="8" v-if="form.deviceNumber">
              <el-form-item label="设备编号" prop="deviceNumber">
                {{ form.deviceNumber || '-' }}
              </el-form-item>
            </el-col>
            <el-col :span="8" v-if="form.actualVisitStartTime">
              <el-form-item label="实际到访时间" prop="actualVisitStartTime" >
                {{ form.actualVisitStartTime || '-' }}
              </el-form-item>
            </el-col>
            <el-col :span="8" v-if="form.actualVisitEndTime">
              <el-form-item label="实际结束时间" prop="actualVisitEndTime" >
                {{ form.actualVisitEndTime || '-' }}
              </el-form-item>
            </el-col>
            <el-col :span="8" v-if="form.rejectReason">
              <el-form-item label="审批拒绝原因" prop="rejectReason">
                {{ form.rejectReason || '-' }}
              </el-form-item>
            </el-col>
          </el-row>
        </el-card>

      </el-form>
      <el-steps v-if="approvalLogList && approvalLogList.length>0" direction="vertical" :active="approvalLogList.length-1" style="margin-top: 15px;">
        <el-step v-for="(item) in approvalLogList" :key="item.id" icon="el-icon-guide">
          <div slot="title">
            <el-tag size="small" v-if="item.status == 0" type="info">提交申请</el-tag>
            <el-tag size="small" v-if="item.status == 1" type="success">通过申请</el-tag>
            <el-tag size="small" v-if="item.status == 2" type="danger">拒绝申请</el-tag>
            <el-tag size="small" v-if="item.status == 3">访问中</el-tag>
            <el-tag size="small" v-if="item.status == 4" type="warning">离访</el-tag>
          </div>
          <div slot="description" style="padding: 10px 0 20px 0;width: 100%;">
            <el-card style="width: 100%;">
              <div style="margin-bottom: 5px;">操作人：{{item.username}}</div>
              <div style="margin-bottom: 5px;">时间：{{item.createTime}}</div>
              <div>{{item.remark}}</div>
            </el-card>
          </div>
        </el-step>
      </el-steps>
    </div>


  </el-drawer>
</template>

<script>
import DrawerHeader from "@/components/drawerHeader.vue"
import {VisitorApplyApi} from '@/api/server/visitorApply';
import {DmsDeviceApi} from "@/api/server/dmsDevice";
import Clipboard from 'clipboard'

export default {
  name: "detail",
  components: {
    DrawerHeader
  },
  data() {
    return {
      dialogVisble: false,
      submitLoading: false,
      smsLoading: false,
      form: {
        user: {},
      },
      rules: {
      },
      approvalLogList: []
    }
  },
  methods: {
    //关闭抽屉
    handleClose() {
      this.dialogVisble = false;
    },
    //打开对话框
    async show(row) {
      this.form = Object.assign({}, row);
      this.dialogVisble = true;
      this.queryApprovalLog(row.id);
    },
    queryApprovalLog(id){
      VisitorApplyApi.queryApprovalLog(id).then(response => {
        const {code,data} = response;
        if(code == 200){
          if(!data.user){
            data.user = {name: ''};
          }
          this.approvalLogList = data || [];
        }
      })
    },
    copyLink(textToCopy){
      const clipboard = new Clipboard('.copy', {
        text: () => textToCopy // 👈 指定要复制的文本
      })
      clipboard.on('success', e => {
        console.log('复制成功')
        this.$message.success('复制成功')
        clipboard.destroy()
      })
      clipboard.on('error', e => {
        console.log('该浏览器不支持自动复制', e)
        this.$message.error('该浏览器不支持自动复制')
        clipboard.destroy()
      })
    },
    sendSms(){
      this.smsLoading = true;
      VisitorApplyApi.sendVisitorSms(this.form.id).then(response => {
        const {code,data} = response;
        if(code == 200){
          this.$message.success('发送成功')
        }else{
          this.$message.error('发送失败')
        }
      }).finally(() => {
        this.smsLoading = false;
      })
    }
  }
}
</script>

<style scoped>
.visitor-type-card .el-card__header{
  background: #f6f7fb;
  font-weight: bold;
}
::v-deep .el-form-item__label{
  color: #89a;
}
::v-deep .el-form-item__content{
  color: black;
  font-weight: bold;
}
.vistor-box-link{
  width: 100%;
  margin-top: 20px;
  border-radius: 4px;
  padding: 16px 0;
  display: flex;
  justify-content: space-between;
  align-items: center;
  background: #F6F7FB;
  border-radius: 4px;
}
.vistor-box-link .link-text{
  display: flex;
  flex-direction: column;
  margin-left: 10px;
}
.vistor-box-link .link-btns{
  display: flex;
  flex-direction: row;
  align-items: center;
  margin-right: 10px;
}
.vistor-box-link .link-text .link-text-title {
  font-size: 16px;
  color: #32325d;
  font-weight: 400;
  margin-bottom: 4px;
  line-height: 20px;
  word-break: break-all;
}
.vistor-box-link .link-text .link-text-tip {
  font-size: 12px;
  color: #89a;
  font-weight: 400;
  line-height: 17px;
  margin-top: 5px;
}
</style>